<div class="orgbrain-style">
  <div class="flex flex-col p-2 relative">
    <div class="flex flex-col gap-4 w-full">
      <!-- Row: Icon/Pulse (Left) + Text Info (Right) -->
      <div class="flex flex-row gap-6 items-center w-full">
        <!-- Left Side: Profile Image / Fallback Icon + Pulsing Animation -->
        <div class="relative flex items-center justify-center shrink-0">
          <!-- Pulsing Ring -->
          <div
            class="absolute inline-flex h-3/4 w-3/4 rounded-full bg-sky-300 opacity-75 animate-ping inset-0 m-auto"
            style="animation-duration: 3s"
          ></div>

          <!-- Profile Image or Icon -->
          <div
            class="relative flex items-center justify-center w-14 h-14 rounded-full bg-gray-100 overflow-hidden border-4 border-white shadow-lg"
          >
            <img
              *ngIf="inviterPhotoUrl; else fallbackIcon"
              [src]="inviterPhotoUrl"
              alt="Profile"
              class="w-full h-full object-cover"
            />
            <ng-template #fallbackIcon>
              <mat-icon
                class="!text-orgbrain-gray !w-5 !h-5 !leading-none !flex !items-center !justify-center"
                >people</mat-icon
              >
            </ng-template>
          </div>
        </div>

        <!-- Right Side: Content Column -->
        <div class="flex flex-col gap-0 text-left flex-1 min-w-0">
          <h1 class="text-xl font-bold m-0 text-black truncate">
            {{ conversationName }}
          </h1>
          <p class="text-base text-orgbrain-gray m-0">
            <span class="font-bold text-orgbrain-dark">{{ inviterName }}</span>
            {{ joinPromptText }}
          </p>
        </div>
      </div>

      <!-- Actions (Full Width Row) -->
      <mat-dialog-actions class="flex gap-4 justify-center w-full !p-0 !m-0">
        <button
          mat-flat-button
          class="flex-1 !w-fit !bg-red-500 !text-white hover:!bg-red-600 !h-10"
          (click)="onDecline()"
        >
          <div class="flex items-center justify-center gap-2">
            <mat-icon class="!w-5 !h-5 !text-[20px]">call_end</mat-icon>
            {{ declineButtonText }}
          </div>
        </button>
        <button
          mat-flat-button
          class="flex-1 !w-fit !bg-green-600 !text-white hover:!bg-green-700 !h-10"
          (click)="onAccept()"
          cdkFocusInitial
        >
          <div class="flex items-center justify-center gap-2">
            <mat-icon class="!w-5 !h-5 !text-[20px]">phone_in_talk</mat-icon>
            {{ acceptButtonText }}
          </div>
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
